import * as style from './style.css';
import classes from '../../framework/framework/tools/classes';
import TextSplitter from '../../components/textSplitter/TextSplitter';
import ExpandLessIcon from '../../assets/icons/ExpandLessIcon';
import ExpandMoreIcon from '../../assets/icons/ExpandMoreIcon';
import React = require('react');

interface IProps {
    model: any;
    closeable?: boolean;
}
interface IState {
    isOpen: boolean;
}

export class NewsRowComponent extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    render() {
        const model = this.props.model;
        return <div key={model.id} className={style.dataRow}>
            <div className={classes(style.header, style.dataRowElem, this.props.closeable && style.closeable)}>
                <div>
                    {model.header}
                </div>
                {this.props.closeable === true &&
                    <div>
                        {this.state.isOpen
                            ? <ExpandLessIcon onClick={() => this.setState({ isOpen: false })} />
                            : <ExpandMoreIcon onClick={() => this.setState({ isOpen: true })} />}
                    </div>}
            </div>

            {this.state.isOpen &&
                <div className={classes(style.content, style.dataRowElem)}>
                    <TextSplitter htmlTags={true} text={model.content} />
                </div>
            }
        </div>;
    }
}
